import React from "react";
import { Sheet, SheetContent } from "src/components/ui/sheet";
import { Survey } from "src/redux/survey/survey.types";
import SurveyAssignClient from "./survey-assign-client";

interface SurveyDrawerProps {
  open: boolean;
  type: 'assign-client' | null;
  activeSurvey: Survey | null;
  onOpenChange: () => void;
}

const SurveyDrawer: React.FC<SurveyDrawerProps> = ({
  open,
  type,
  onOpenChange,
  activeSurvey,
}) => {
  if (!open) return null;

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <SheetContent
        side="right"
        className="!w-[75vw] sm:!w-[50vw] !max-w-none overflow-y-auto bg-white"
      >
        {type === 'assign-client' && (
          <SurveyAssignClient
            activeSurvey={activeSurvey}
            onCancel={() => onOpenChange()}
            onSave={() => onOpenChange()}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};

export default SurveyDrawer;
